import { useDetailApi } from "../../../swr";
import { adminAiChatService, type AdminAiChatPartnerCost } from "../../api_client";

export function usePartnerAiCost(partnerId: number) {
  return useDetailApi<AdminAiChatPartnerCost>({
    key: `/admin/ai-chat/user-cost/${partnerId}`,
    serviceMethod: () => adminAiChatService.partnerCost(partnerId),
  });
}
